import { hide, show, toggle } from "slidetoggle";
import { Breakpoints } from "../../breakpoints";
import { slideToggleDefaults } from "../modules/_config";


class SiteHeader extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }
  init() {
    const hoverMenuItems = this.querySelectorAll('.menu-item > a');
    const accordionMenuButtons = this.querySelectorAll('.menu-item--has-children > button');

    // Hover functionality desktop
    hoverMenuItems.forEach((item) => {
      const linkParent = item.parentElement;
      const hasSubMenu = linkParent.classList.contains('menu-item--has-children')
      const subMenu = linkParent.querySelector('.menu-container');
      const triggerButton = linkParent.querySelector('button');
      const parentMenuContainer = item.closest('.menu-container');
      const otherSubMenus = [...parentMenuContainer.querySelectorAll('.menu-container')].filter(otherSubMenu => otherSubMenu != subMenu);

      const removeOtherLinkFocusWithin = () => this
        .querySelectorAll('.menu-item > a.is-hover-within')
        .forEach(otherLink =>
          otherLink.classList.remove('is-hover-within'));

      const closeOtherMenuItems = () => {
        otherSubMenus.map(otherSubMenu => {
          if (!otherSubMenu.contains(document.activeElement)) {
            removeOtherLinkFocusWithin();
            hide(otherSubMenu, slideToggleDefaults)
          }
        });
      }

      const opeMenuItem = (e) => {
        if (window.innerWidth > Breakpoints.lg) {
          closeOtherMenuItems();
          if (hasSubMenu) {
            removeOtherLinkFocusWithin();
            item.classList.add('is-hover-within');
            triggerButton.classList.add('open');
            show(subMenu, slideToggleDefaults)
            parentMenuContainer?.classList.add('sub-open');

          }
        }
      };

      const closeMenuItem = (e) => {
        if (window.innerWidth > Breakpoints.lg) {
          if (hasSubMenu) {
            item.classList.remove('is-hover-within');
            triggerButton.classList.remove('open');
            hide(subMenu, slideToggleDefaults)
            parentMenuContainer?.classList.remove('sub-open');
          }
        }
      };


      linkParent.addEventListener('mouseenter', opeMenuItem);
      item.addEventListener('focus', opeMenuItem);

      linkParent.addEventListener('mouseleave', closeMenuItem);
      // item.addEventListener('blur', closeMenuItem);
    });

    // Click functionality mobile
    accordionMenuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.innerWidth <= Breakpoints.lg) {
          const subMenu = button.nextElementSibling;

          button.classList.toggle('open');
          toggle(subMenu, slideToggleDefaults);

          // Close others
          button.parentElement.parentElement.querySelectorAll('li > button').forEach((otherButton) => {
            if (otherButton != button) {
              const otherSubMenu = otherButton.nextElementSibling;
              otherButton.classList.remove('open');
              hide(otherSubMenu, slideToggleDefaults);
            }
          })
        }
      });
    });
  }
}

customElements.define('site-header', SiteHeader);
